// Visitor identity + role-feature flags, shared across widgets.
//
// Identity travels in the storefront's commerce_features JWT + Session cookies.
// Because the embeds call the parts-finder API cross-origin, we forward those
// cookies as headers. Results are cached on window.* so sibling widgets in the
// same bundle (and the legacy standalone scripts, which use the same globals)
// share one /api/features round-trip.

import { getAppBaseUrl } from './config.js';

export function readCookie(name) {
  try {
    var cookies = (document.cookie || '').split(';');
    var prefix = name + '=';
    for (var i = 0; i < cookies.length; i++) {
      var c = cookies[i].trim();
      if (c.indexOf(prefix) === 0) {
        try { return decodeURIComponent(c.substring(prefix.length)); }
        catch (e) { return c.substring(prefix.length); }
      }
    }
  } catch (e) { /* ignore */ }
  return '';
}

export function getSessionRef() {
  return readCookie('Session');
}

/**
 * Resolve the current visitor's role-feature flags. Reuses the shared window
 * cache/promise so only ONE /api/features request is made per page. Fails OPEN:
 * any error resolves to {} (widgets treat missing flags as "allowed").
 */
export function loadFeatures() {
  try {
    if (window.__PARTS_FINDER_FEATURES__) return Promise.resolve(window.__PARTS_FINDER_FEATURES__);
    if (window.__PARTS_FINDER_FEATURES_PROMISE__) return window.__PARTS_FINDER_FEATURES_PROMISE__;
  } catch (e) { /* ignore */ }

  var jwt = readCookie('commerce_features');
  var sessionRef = readCookie('Session');
  var headers = { 'Accept': 'application/json' };
  if (jwt) headers['X-Commerce-Features'] = jwt;
  if (sessionRef) headers['X-Session-Reference'] = sessionRef;

  var base = getAppBaseUrl().replace(/\/$/, '');
  var p = fetch(base + '/api/features', { headers: headers, cache: 'no-store' })
    .then(function (r) { return r.ok ? r.json() : { features: {} }; })
    .then(function (data) {
      var f = (data && data.features) || {};
      try {
        window.__PARTS_FINDER_FEATURES__ = f;
        window.__PARTS_FINDER_FEATURES_ROLE_KEY__ = (data && data.roleKey) || null;
      } catch (e) { /* ignore */ }
      return f;
    })
    .catch(function () { return {}; });

  try { window.__PARTS_FINDER_FEATURES_PROMISE__ = p; } catch (e) { /* ignore */ }
  return p;
}

/** True when the resolved role is anonymous / Public. */
export function isAnonymous() {
  try {
    var rk = window.__PARTS_FINDER_FEATURES_ROLE_KEY__;
    return !rk || rk === 'Public';
  } catch (e) { return false; }
}

/**
 * True when the resolved FrontendUserRole is a branch (staff) account. Branch
 * users see their own branch's stock AND the Head Office backup stock broken
 * out as separate rows (rather than the single combined figure other roles
 * see). Matched case-/space-insensitively — mirrors useIsBranch() on the React
 * side. False until loadFeatures() has resolved the role.
 */
export function isBranch() {
  try {
    var rk = window.__PARTS_FINDER_FEATURES_ROLE_KEY__;
    return !!rk && String(rk).toLowerCase().replace(/[^a-z0-9]/g, '') === 'branch';
  } catch (e) { return false; }
}
